export default class kbIpcClass {
  get table() {
    return this.ipc.table;
  }

  get tbody() {
    return this.ipc.tbody;
  }

  get thead() {
    return this.ipc.thead;
  }

  get svg() {
    return this.ipc.svg;
  }
  get hotspotGroup() {
    if (this.ipc.hasOwnProperty("hotspotGroup")) {
      return this.ipc.hotspotGroup[0][0];
    } else {
      return null;
    }
  }

  get imageSRC() {
    return this.ipc.imgSrc;
  }
  get title() {
    return this.ipc.title;
  }
  set addToCart(bool) {
    this._addToCart = bool;
  }
  set zoomCallback(fn) {
    this._zoomCallback = fn;
  }
  set hsClickCallback(fn) {
    this._hsClickCallback = fn;
  }
  set rowClickCallback(fn) {
    this._rowClickCallback = fn;
  }
  set orderBtnClickCallback(fn) {
    this._orderBtnClickCallback = fn;
  }
  set readyCallback(fn) {
    this._readyCallback = fn;
  }
  set imageDiv(el) {
    this.ipc.imageDiv = el;
  }

  constructor() {
    this.ipc = {}; //central object to hold marshelled information
  }

  init(strHTML) {
    var xmlString = strHTML,
      parser = new DOMParser(),
      doc = parser.parseFromString(xmlString, "text/xml");
    this.ipc.doc = doc;
    this._extractTitle();
    this.ipc.hsArray = this._createHSArray();
    this.imgElement = this.ipc.doc.querySelector(".PNGPartsImage");
    if (this.imgElement) {
      this._loadImgForDimensions();
      this._modifyTable();
    } else {
      this._modifyTable();
      this._readyCallback();
    }
  }

  _loadImgForDimensions() {
    var imgElement = this.ipc.doc.querySelector(".PNGPartsImage");
    this.ipc.imgPoperties = {};
    this.ipc.imgPoperties.imgSrc =
      "/kb/jrest/getResource?kbrid=" + imgElement.getAttribute("src");
    var img = new Image();
    img.onload = function () {
      this.ipc.imgPoperties.rawImgHeight = img.height;
      this.ipc.imgPoperties.rawImgWidth = img.width;
      img = null;
      this._continue();
    }.bind(this);
    img.src = this.ipc.imgPoperties.imgSrc;
  }

  _continue() {
    this._extractImageProps();
    this._createSVG();
    this._addHotSpotsToSVG();
    this._readyCallback();
  }

  _extractTitle() {
    var el = this.ipc.doc.querySelector("h1");
    if (el) {
      this.ipc.title = el.innerHTML;
    }
  }

  _createHSArray() {
    var el = this.ipc.doc.querySelector(".PNGPartsImageMap");
    if (el) {
      var imgMap = el.children[1];
      var circles = [];
      var children = [].slice.call(imgMap.children);
      var aTmpCoords = null;
      children.forEach(function (hs) {
        var circle = {};
        var tmpHref = hs.getAttribute("href");
        var aTmpHref = tmpHref.split("_");
        circle.coid = aTmpHref[aTmpHref.length - 1];
        var tmp = hs.getAttribute("title");
        var aTmp = tmp.split("_");
        circle.title = aTmp[1];
        circle.pid = aTmp[3];
        circle.inum = aTmp[5];
        var tmpCoords = hs.getAttribute("coords");
        if (tmpCoords.includes(",")) {
          aTmpCoords = tmpCoords.split(",");
        } else {
          aTmpCoords = tmpCoords.split(" ");
        }
        circle.cx = aTmpCoords[0];
        circle.cy = aTmpCoords[1];
        circle.r = aTmpCoords[2];
        circles.push(circle);
      });
      return circles;
    }
  }

  _extractImageProps() {
    this.ipc.imgPoperties.imgSrc =
      "/kb/jrest/getResource?kbrid=" + this.imgElement.getAttribute("src");
    this.ipc.imgPoperties.rawImgWidth = parseInt(
      this.imgElement.getAttribute("rawWidth")
    );
    this.ipc.imgPoperties.rawImgHeight = parseInt(
      this.imgElement.getAttribute("rawHeight")
    );
    this.ipc.imgPoperties.imgHeight = 500;
    this.ipc.imgPoperties.height = 500;
    this.ipc.imgPoperties.translate0 = [0, 0];
    this.ipc.imgPoperties.scale0 = 1; // Initial offset & scale
    this.ipc.imgPoperties.ratio = this.ipc.imgPoperties.rawImgHeight / 500;
    this.ipc.imgPoperties.imgWidth =
      this.ipc.imgPoperties.rawImgWidth / this.ipc.imgPoperties.ratio;
    this.ipc.imgPoperties.width = parseInt(
      this.ipc.imgPoperties.rawImgWidth / this.ipc.imgPoperties.ratio
    );
    this.ipc.imgPoperties.HFactor =
      this.ipc.imgPoperties.imgHeight / this.ipc.imgPoperties.rawImgHeight;
    this.ipc.imgPoperties.WFactor =
      this.ipc.imgPoperties.imgWidth / this.ipc.imgPoperties.rawImgWidth;
  }

  _createSVG() {
    this.ipc.svg = d3
      .select(this.ipc.imageDiv)
      .append("svg")
      .attr("width", this.ipc.imgPoperties.width + "px")
      .attr("height", this.ipc.imgPoperties.height + "px");
    this.ipc.svg
      .append("rect")
      .attr("class", "overlay")
      .attr("fill", "white")
      .attr("width", this.ipc.imgPoperties.width + "px")
      .attr("height", this.ipc.imgPoperties.height + "px");
    //this.ipc.               svg.append("g").attr("transform", "translate(" + this.ipc.imgPoperties.translate0 + ")scale(" + this.ipc.imgPoperties.scale0 + ")").call(d3.behavior.zoom().scaleExtent([1, 8]).on("zoom", this._zoomCallback ) ).append("g");
    this.ipc.svg = this.ipc.svg
      .append("g")
      .attr(
        "transform",
        "translate(" +
          this.ipc.imgPoperties.translate0 +
          ")scale(" +
          this.ipc.imgPoperties.scale0 +
          ")"
      )
      .call(
        d3.behavior.zoom().scaleExtent([1, 8]).on("zoom", this._zoomCallback)
      )
      .append("g");
    this.ipc.svg
      .append("image")
      .attr("width", this.ipc.imgPoperties.imgWidth + "px")
      .attr("height", this.ipc.imgPoperties.imgHeight + "px")
      .attr(
        "x",
        this.ipc.imgPoperties.width / 2 -
          this.ipc.imgPoperties.imgWidth / 2 +
          "px"
      )
      .attr("xlink:href", this.ipc.imgPoperties.imgSrc);
    //To center image, also need to modify circle locations.
    this.ipc.hotspotGroup = this.ipc.svg
      .append("g")
      .attr("id", "myGroup")
      .append("g");
  }

  _addHotSpotsToSVG() {
    this.ipc.hsArray.forEach(
      function (hs) {
        //var myCircle = document.createElement("circle");
        var myCircle = this.ipc.hotspotGroup
          .append("circle")
          .attr("coid", hs.coid)
          .attr("id", "hs" + hs.inum)
          .attr("title", "title")
          .attr("fill", "red")
          .attr("opacity", "0.0")
          .attr("cx", hs.cx * this.ipc.imgPoperties.WFactor)
          .attr("cy", hs.cy * this.ipc.imgPoperties.HFactor)
          .attr("r", hs.r * this.ipc.imgPoperties.WFactor * hotspotfactor)
          .attr("indexNum", hs.inum)
          .attr("partNum", hs.pid);
        //.attr("cx", (hs.cx * WFactor) + (this.miData.width/2)-(this.miData.imgWidth/2) )
        //.attr("cy", (hs.cy *HFactor) + (this.miData.height/2)-(this.miData.imgHeight/2) )
        //myCircle.addEventListener("click", this._hsClickCallback );
        myCircle[0][0].addEventListener("click", this._hsClickCallback);
        //this.ipc.hotspotGroup[0][0].appendChild(myCircle)
      }.bind(this)
    );
  }

  _modifyTable() {
    this.ipc.table = this.ipc.doc.querySelector(".PartsTable");
    this.ipc.tbody = this.ipc.table.querySelector(".PartsTable tbody");
    this.ipc.thead = this.ipc.table.querySelector(".PartsTable thead");
    let orderText = orderUrl ? "Order Part" : "Add to cart";
    var nullRows = [];
    var caption = this.ipc.table.querySelector("caption");
    if (caption) {
      caption.innerHTML = "";
    }

    if (this._addToCart) {
      var th = document.createElement("th");
      th.innerHTML = "order";
      th.setAttribute("class", "entry cellrowborder");
      th.setAttribute("style", "vertical-align:top;");
      this.ipc.thead.children[0].appendChild(th);
    }
    for (var i = 0; i < this.ipc.tbody.children.length; i++) {
      var row = this.ipc.tbody.children[i];
      var aRoId = row.getAttribute("id").split("_");
      var coid = aRoId[aRoId.length - 1];

      if (row.children[0].innerText == "null") {
        row.children[0].innerText = "n/a";
      }
      var item = {};
      item.coid = coid;
      item.title = "table title"; //this.tableTitle
      item.indexNum = row.cells[0].innerText;
      item.partno = row.cells[1].innerText;
      item.description = row.cells[2].innerText;
      //item.qty=row.cells[3].innerText;
      row.setAttribute("item", JSON.stringify(item));
      row.setAttribute("coid", coid);
      row.setAttribute("index-num", item.indexNum);

      if (row.children[0].innerText != "n/a") {
        row.classList.add("datarow");
        row.addEventListener("click", this._rowClickCallback);
      } else {
        row.classList.add("narow");
      }
      if (this._addToCart) {
        var td = document.createElement("td");
        if (item.indexNum.trim() != "") {
          var btn = document.createElement("div");
          var icon = document.createElement("iron-icon");
          //icon.setAttribute("icon","vaadin:cart");
          //btn.appendChild(icon);
          btn.innerText = orderText;
          btn.setAttribute("class", "orderbtn");
          item.title = "TITLE"; //this.ipcTitle
          btn.setAttribute("item", JSON.stringify(item));
          btn.addEventListener("click", this._orderBtnClickCallback);
          td.appendChild(btn);
        }
        row.appendChild(td);
      }
    }
    /*
        if(nullRows.length>0){
            nullRows.slice().reverse().forEach(rowIdx => this.ipc.table.deleteRow(rowIdx+1))
        */
  }
}
